import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { __, getConfig } from "@jti/fe-common";
import { Button, PageTitle, TranslationHtmlWrapper } from "@jti/ui";
import ROUTES_PATHS from "../../../constants/routes";
import styles from "./EmailUpdate.module.scss";
var UPDATE_EMAIL_ERROR_STATUSES;
(function (UPDATE_EMAIL_ERROR_STATUSES) {
    UPDATE_EMAIL_ERROR_STATUSES["UNAUTHORIZED"] = "401";
    UPDATE_EMAIL_ERROR_STATUSES["NOT_FOUND"] = "404";
    UPDATE_EMAIL_ERROR_STATUSES["CONFLICT"] = "409";
})(UPDATE_EMAIL_ERROR_STATUSES || (UPDATE_EMAIL_ERROR_STATUSES = {}));
const generateTextMap = () => {
    const textMap = {
        [UPDATE_EMAIL_ERROR_STATUSES.UNAUTHORIZED]: {
            title: __("login.update_email.expired.title"),
            body: __("login.update_email.expired.body"),
        },
        [UPDATE_EMAIL_ERROR_STATUSES.NOT_FOUND]: {
            title: __("login.update_email.invalid.title"),
            body: _jsx(TranslationHtmlWrapper, { text: "login.update_email.invalid.body", htmlData: [getConfig().CONTACT_US_URL] }),
        },
        [UPDATE_EMAIL_ERROR_STATUSES.CONFLICT]: {
            title: __("login.update_email.already_verified.title"),
            body: __("login.update_email.already_verified.body"),
        },
    };
    return textMap;
};
const EmailUpdate = ({ code }) => {
    const history = useHistory();
    const textMap = useMemo(() => generateTextMap(), []);
    const errorCode = String(code);
    const handleLoginButtonClick = () => {
        history.push(ROUTES_PATHS.login);
    };
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { className: styles.title, title: __("login.update_email.title"), text: textMap[errorCode].title }), _jsxs("div", { className: styles.container, "data-testid": "emailUpdateConfirmationPage", children: [_jsx("p", { children: textMap[errorCode].body }), _jsx(Button, { className: styles.loginButton, "data-testid": "loginButton", onClick: handleLoginButtonClick, children: __("login.login_button_label") })] })] }));
};
export default EmailUpdate;
